<app-os-actions-case
  [claim]="claim"
  [showImage]="false"
  [showDetails]="true"
  >
</app-os-actions-case>
